import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import courseReducer from './slices/courseSlice'

const persistedUser = JSON.parse(localStorage.getItem("user"))
const persistedAccess = localStorage.getItem("access")

export const store = configureStore({
  reducer: {
    auth: authReducer,
    courses: courseReducer,
  },
  preloadedState: {
    auth: {
      user: persistedUser,
      access: persistedAccess,
      refresh: null,
      status: 'idle',
      error: null,
      registerStatus: 'idle',
      registerError: null,
    },
  },
})
